<template>
  <div>
    <div v-for="(score, index) in scores" :key="index">
      <b-badge :variant="getVariant(score)">{{ score }}</b-badge>
      <span class="ml-1">{{ round[score] }}x</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoundHistogrammInfo",
  props: {
    round: {
      default: undefined
    }
  },
  computed: {
    scores() {
      if (!this.round) {
        return [];
      }
      return Object.keys(this.round).reverse();
    }
  },
  methods: {
    getVariant(score) {
      if (score == "?") {
        return "secondary";
      }
      if (score <= 3) {
        return "danger";
      }
      if (score <= 7) {
        return "warning";
      }
      return "info";
    }
  }
};
</script>
